import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Cart, CartLineSources } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import * as ProductActions from './store/actions';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss', './product.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon, AgrI18nSharedModule],
})
export class ProductComponent {
  @Input() cart?: Cart;
  @ViewChild('openProductSearchButton') openProductSearchButton: MatButton;

  constructor(private readonly store: Store) {}

  handleClick(): void {
    this.store.dispatch(
      ProductActions.openSearchDialog({
        cart: this.cart,
        htmlButtonRef: this.openProductSearchButton._elementRef.nativeElement as HTMLButtonElement,
        source: CartLineSources.CART_SEARCH,
      }),
    );
  }
}
